import { Menu, MenuButton, MenuList } from "@chakra-ui/react";
import React, { ReactNode } from "react";

interface menuProps {
  menuHeader: ReactNode;
  menuOptions: ReactNode;
  placement?: any;
}

const CustomMenu = ({ menuHeader, menuOptions, placement }: menuProps) => {
  return (
    <Menu autoSelect={false} placement={placement}>
      <MenuButton>{menuHeader}</MenuButton>

      <MenuList borderRadius="lg" boxShadow="md" borderWidth="1px" p={2}>
        {menuOptions}
        {/* {menuOptions.map((option: any, index: number) => {
          return (
            <MenuItem key={index}>{option}</MenuItem>
          );
        })} */}
      </MenuList>
    </Menu>
  );
};

export default CustomMenu;
